module.exports = __webpack_public_path__ + "static/media/Oliva-Serif-Alts-2.6630d501.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Oliva-Serif-Alts-2.ttf
// module id = 3394
// module chunks = 71